import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {
    FormItemTextComponent
} from "../../../common/forms/form-item-text/form-item-text.component";
import {
    MenuService,
    SettingsSaveService,
    SubtitlesService
} from "../../../core";
import {
    FormActionButtonsComponent
} from "../../../common/forms/form-action-buttons/form-action-btns.component";
import {
    FormButtonComponent
} from "../../../common/forms/form-button/form-button.component";
import {
    FormBuilder, FormControl,
    FormGroup,
    ReactiveFormsModule,
    Validators
} from "@angular/forms";
import {NgClass} from "@angular/common";

@Component({
    selector: 'pin-form',
    standalone: true,
    imports: [
        FormItemTextComponent,
        FormActionButtonsComponent,
        FormButtonComponent,
        ReactiveFormsModule,
        NgClass,
    ],
    templateUrl: './pin-form.component.html',
    styleUrl: './pin-form.component.scss'
})
export class PinFormComponent implements OnInit {
    @Output() close = new EventEmitter();
    pinForm: FormGroup;

    constructor(
        private fb: FormBuilder,
        private menu: MenuService,
        private subtitles: SubtitlesService,
        public settingsSave: SettingsSaveService
    ) {
    }

    ngOnInit(): void {
        this.pinForm = this.fb.group({
                pin1: [ null as null | string, [Validators.pattern(/^[0-9]$/)]],
                pin2: [ null as null | string, [Validators.pattern(/^[0-9]$/)] ],
                pin3: [ null as null | string, [Validators.pattern(/^[0-9]$/)] ],
                pin4: [ null as null | string, [Validators.pattern(/^[0-9]$/)] ],
            },
        );
    }

    get pin1Control() {
        return this.pinForm.get('pin1') as FormControl;
    }
    get pin2Control() {
        return this.pinForm.get('pin2') as FormControl;
    }
    get pin3Control() {
        return this.pinForm.get('pin3') as FormControl;
    }
    get pin4Control() {
        return this.pinForm.get('pin4') as FormControl;
    }

    isInvalid1(): boolean {
        return this.pin1Control.invalid && (this.pin1Control.dirty || this.pin1Control.touched);
    }

    isInvalid2(): boolean {
        return this.pin2Control.invalid && (this.pin2Control.dirty || this.pin2Control.touched);
    }

    isInvalid3(): boolean {
        return this.pin3Control.invalid && (this.pin3Control.dirty || this.pin3Control.touched);
    }

    isInvalid4(): boolean {
        return this.pin4Control.invalid && (this.pin4Control.dirty || this.pin4Control.touched);
    }

    subtitle(val: number): string {
        return val !== 0 ? this.subtitles.setSubtitle(val) : '';
    }

    getElement() {
        const pin1 = this.pinForm.get('pin1').value ?? '';
        const pin2 = this.pinForm.get('pin2').value ?? '';
        const pin3 = this.pinForm.get('pin3').value ?? '';
        const pin4 = this.pinForm.get('pin4').value ?? '';

        this.menu.password = `${pin1}${pin2}${pin3}${pin4}`;
        this.settingsSave.getPasswordedElements()
    }
}
